/**
 * getSessionCollectionName
 *
 * Returns the current session collection name.
 *
 * Non-hook imperative accessor for use outside React components.
 * Reads from Redux state (hydrated from persisted localStorage on startup).
 */
import { getStore } from '@/store/store-proxy';
import { selectCollectionName } from '@/store/slices/sessionSlice';
export const getSessionCollectionName = () => {
    const state = getStore().getState();
    return selectCollectionName(state);
};
